import React from 'react';

import Chip from 'components/common/Chip/Chip';
import MergeClassNames from 'utils/MergeClassNames';

import { getSeedOptionDisplayLabel, StepSelectorOption } from './stepConfig';

interface SelectionChipsProps {
  items: StepSelectorOption[];
  onRemoveItem: (id: string) => void;
  getItemLabel?: (item: StepSelectorOption) => string;
  /** One scrolling line instead of wrapping, so the row never grows. */
  singleLine?: boolean;
}

const getItemChipId = (item: StepSelectorOption): string =>
  item.globalId ?? item.item;

const SelectionChips: React.FC<SelectionChipsProps> = ({
  items,
  onRemoveItem,
  getItemLabel = getSeedOptionDisplayLabel,
  singleLine = false,
}) => (
  <div
    className={MergeClassNames(
      'flex items-center gap-1.5',
      singleLine ? 'flex-nowrap overflow-x-auto' : 'mt-2 flex-wrap'
    )}
  >
    {items.map((item) => {
      const itemId = getItemChipId(item);
      return (
        <Chip
          key={itemId}
          id={itemId}
          label={getItemLabel(item)}
          selected
          truncate
          onClose={onRemoveItem}
        />
      );
    })}
  </div>
);

export default SelectionChips;
